import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSendIcon = (
  { title, titleId, strokeWidth = 2, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99974 1.79297L12.8735 6.66674L12.1664 7.37385L8.49974 3.70718V14.0001H7.49974V3.70718L3.83308 7.37385L3.12598 6.66674L7.99974 1.79297Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="square"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSendIcon);
export default ForwardRef;
